import React from 'react';
import styled from 'styled-components';

const ThisLoader = styled.div`
  display: block;
  transform: rotate(0deg);

  width: 40px;
  height: 40px;
  border: 3px solid #ddd;
  border-top: 3px solid #00AD83;
  border-radius: 50%;
  animation: spin 2s linear infinite;
  margin: 0 auto;
`;

const Loader = () => (
  <ThisLoader />
);

export default Loader;




// WEBPACK FOOTER //
// ./src/components/ui/Loader.js